import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetMeterModuleFilesArg, GetMeterModuleFilesResult } from '../../../lib/services';

const TEN_MINUTES = 10 * 60 * 1000;

export const useMeterModuleFiles = (
  arg: GetMeterModuleFilesArg,
  options?: UseQueryOptions<GetMeterModuleFilesResult, Error>,
): UseQueryResult<GetMeterModuleFilesResult> => {
  const { meterModulesApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.meterModules.files(arg.moduleId, arg),
    queryFn: async ({ signal }) => await meterModulesApiClient.getFiles({ ...arg, signal }),
    staleTime: TEN_MINUTES,
    cacheTime: TEN_MINUTES,
    ...options,
  });
};
